import { render, staticRenderFns } from "./MenuDropdown.vue?vue&type=template&id=24b27e13&scoped=true&"
import script from "./MenuDropdown.vue?vue&type=script&lang=js&"
export * from "./MenuDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MenuDropdown.vue?vue&type=style&index=0&id=24b27e13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b27e13",
  null
  
)

export default component.exports